import {
  INICIALITZAR,
  OBTENIR_INDIVIDUS_LLISTAT,
  OBTENIR_INDIVIDU_ID,
  OBTENIR_DADES_INDIVIDU,
  ESBORRAR_INDIVIDU_SELECCIONAT,
  INTRODUCCIO_OBTENIR_DADES
} from "../../actions/actionTypes";
import { esObjecteBuit } from "../utils";

const ESTAT_INICIAL = {
  introduccio: {},
  llistat: [],
  idIndividuSeleccionat: null,
  individuSeleccionat: {},
  numObservacions: null
};

const individusReducer = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${INTRODUCCIO_OBTENIR_DADES}_SUCCESS`:
      return {
        ...state,
        introduccio:
          action.payload && action.payload.individus
            ? action.payload.individus
            : []
      };

    case `${OBTENIR_INDIVIDUS_LLISTAT}_EN_CURS`:
    case `${OBTENIR_DADES_INDIVIDU}_EN_CURS`:
      return {
        ...state
      };

    case `${OBTENIR_INDIVIDUS_LLISTAT}_SUCCESS`:
      return {
        ...state,
        llistat: action.payload
      };

    case `${OBTENIR_INDIVIDUS_LLISTAT}_ERROR`:
    case `${OBTENIR_DADES_INDIVIDU}_ERROR`:
      return {
        ...state,
        error: action.error
      };

    case `${OBTENIR_DADES_INDIVIDU}_SUCCESS`:
      return {
        ...state,
        individuSeleccionat: action.payload.individu,
        numObservacions: action.payload.numObservacions
      };

    case OBTENIR_INDIVIDU_ID:
      return {
        ...state,
        idIndividuSeleccionat: action.payload
      };

    case ESBORRAR_INDIVIDU_SELECCIONAT:
      return {
        ...state,
        idIndividuSeleccionat: null,
        individuSeleccionat: {}
      };

    default:
      return state;
  }
};

export default individusReducer;

const esIndividuActiu = individu => individu.dataBaixa === null;
const esIndividuInactiu = individu => !esIndividuActiu(individu);
const getPeticioEnCurs = state => state.peticioEnCurs;
const totsIndividus = state => state.individus;
const getIndividusPerEstat = (state, estatIndividu) => {
  const individus = getIndividus(state);
  if (!individus) {
    return null;
  }

  var individusPerEstat = {};
  Object.keys(individus).forEach(idIndividu => {
    const individu = individus[idIndividu];
    if (estatIndividu(individu)) {
      individusPerEstat[idIndividu] = individu;
    }
  });

  return individusPerEstat;
};

export const getIndividus = state => {
  const individus = totsIndividus(state);
  if (!individus) {
    return null;
  }
  return individus;
};

export const getIndividusLlistat = state => {
  return state.llistat;
};

export const getPeticioIndividusEnCurs = state => {
  const peticioEnCurs = getPeticioEnCurs(state);
  if (typeof peticioEnCurs !== "boolean") {
    return null;
  }
  return peticioEnCurs;
};

export const getPeticioIndividusError = state => state.error;

export const getIndividusPerIndret = (
  indretsActius,
  individus,
  idIndretSeleccionat
) => {
  if (
    !indretsActius ||
    !individus ||
    esObjecteBuit(individus) ||
    !indretsActius[idIndretSeleccionat]
  )
    return null;

  const idIndividusObservadorSeleccionat =
    indretsActius[idIndretSeleccionat].individus;
  return idIndividusObservadorSeleccionat.map(idIndividu => {
    return { id: idIndividu, nom: individus[idIndividu].nom }; // assumim que les dades seràn correctes
  });
};

export const getDadesIndividu = state => {
  return state.individuSeleccionat;
};

export const getIdIndividu = state => {
  return state.idIndividuSeleccionat;
};

export const getIndividuPerId = state => {
  const individusLlistat = state.individus;
  const individuId = state.idIndividuSeleccionat;

  return individusLlistat[individuId];
};

export const getIndividusActius = state => {
  return getIndividusPerEstat(state, esIndividuActiu);
};

export const getIndividusInactius = state => {
  return getIndividusPerEstat(state, esIndividuInactiu);
};

export const getIndividusAsArray = state => {
  const individusIndexatsPerId = getIndividus(state);
  return Object.keys(individusIndexatsPerId).map(idIndividu => ({
    ...individusIndexatsPerId[idIndividu],
    id: parseInt(idIndividu)
  }));
};

export const getNumObservacions = state => {
  return state.numObservacions;
};
